module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.paginated ? 'paginated' : ''
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paginated || _vm.isActive),
      expression: "!paginated || isActive"
    }],
    staticClass: "rf-section",
    class: _vm.computedClass,
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm._onEnterKey($event)
      }
    }
  }, [_vm._t("title"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.paginated ? '' : 'section'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive || _vm.isComplete),
      expression: "isActive || isComplete"
    }],
    staticClass: "rf-section-content"
  }, [_vm._t("default")], 2)])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e78a7df","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frontend/components/RfSection.vue
// module id = 253
// module chunks = 0